import React from 'react';
import { Link } from 'react-router-dom';
// import ReactDOM from 'react-dom';
// import jQuery from 'jquery';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import * as SVGICONS from '../../images/img/images';
import * as specialistActions from '../../actions/specialistActions';
import * as signinActions from '../../actions/signinActions';
// import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import * as SVGICONS from '../../images/img/images';
import { confirmAlert } from 'react-confirm-alert';


import {
	Modal,
} from 'react-bootstrap';
import classNames from 'classnames';
import validator from './../common/validator.js';
const autoBind = require('auto-bind');
//login container component
class Signin extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.deleteBlockingEvent = this.deleteBlockingEvent.bind(this);
		this.state = {
			deletingEvent: false,
			selectedPeriod: '',
		}
	}
	componentWillReceiveProps(nextProps) {
		console.log("===>>>nextProps==>>", nextProps)
		if (nextProps.specialist.specialistBlockings != undefined && this.state.deletingEvent) {
			this.setState({
				deletingEvent: false
			});
			this.props.hideEventDetailsModal();
		}
	}

	onChangeSelectPeriod = (e) => {
		this.setState({
			selectedPeriod: e.currentTarget.value,
		})
	}

	submitDeleteBlocking = (onClose) => {
		
		// return
		if (this.state.selectedPeriod == 'only') {
			let userToken = localStorage.getItem('token');
			let specialistId = localStorage.getItem('userId');
			let obj = {
				userToken: userToken,
				specialistId: specialistId,
				// event: event.extendedProps,
				userlocation: moment.tz.guess(),
				updateFlag: true,
				event: this.props.eventData.extendedProps

			};
			this.setState({
				deletingEvent: true
			})
			this.props.actions.deleteRecurringEvents(obj, this.props);
		} else if (this.state.selectedPeriod == 'all') {
			let userToken = localStorage.getItem('token');
			let specialistId = localStorage.getItem('userId');
			let obj = {
				userToken: userToken,
				specialistId: specialistId,
				// event: event.extendedProps,
				userlocation: moment.tz.guess(),
				event: this.props.eventData.extendedProps
			};
			this.setState({
				deletingEvent: true
			})
			this.props.actions.deleteRecurringEvents(obj, this.props);
		}
		onClose()
	}

	deleteBlockingEvent = (event) => {
		
		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div className='custom-ui'>
						<h1>How do you like to delete this blocking?</h1>
						<div className="col-sm-4">
							{/* <div className="borderR"> */}
							<div className="radio radio-primary radio-period">
								<input type="radio" name="recurrence" id="only" value="only" onChange={this.onChangeSelectPeriod} /* checked={this.state.recurrence? this.state.recurrencevalue === 'Male' : ''} */ />
								<label style={{ width: "250px" }} htmlFor="only"> Delete This Blocking only </label>
							</div>
							<div className="radio radio-primary radio-period">
								<input type="radio" name="recurrence" id="all" value="all" onChange={this.onChangeSelectPeriod} /* checked={this.state.recurrence? this.state.recurrencevalue === 'Male' : ''} */ />
								<label style={{ width: "250px" }} htmlFor="all"> Delete all Recurring Blocking </label>
							</div>
							{/* </div> */}
						</div>
						<div className="btnSubmit text-center" style={{ margin: "auto" }}>
							<button className="btn btn-primary" onClick={() => this.submitDeleteBlocking(onClose)}>Ok</button>&nbsp;
                        <button className="btn btn-primary" onClick={() => onClose()}>Cancel</button>
						</div>
					</div>
				);
			}
		})
		// confirmAlert({
		// 	title: 'Confirm',
		// 	message: `How do you like to delete this blocking?`,
		// 	width: '650px',
		// 	size: 'large',
		// 	buttons: [
		// 		{
		// 			label: 'This',
		// 			size: 'small',
		// 			onClick: () => {
		// 				let userToken = localStorage.getItem('token');
		// 				let specialistId = localStorage.getItem('userId');
		// 				let obj = {
		// 					userToken: userToken,
		// 					specialistId: specialistId,
		// 					event: event.extendedProps,
		// 					userlocation: moment.tz.guess(),
		// 					updateFlag: true
		// 				};
		// 				this.setState({
		// 					deletingEvent: true
		// 				})
		// 				this.props.actions.deleteRecurringEvents(obj, this.props);

		// 				return;
		// 				
		// 				var selDate = moment.utc(eventDetails.checkappointmentDate);
		// 				var convertedDate = new Date(moment(selDate).local());

		// 				var selStartDate = moment.utc(selectedEvent.start);
		// 				var convertedStartDate = new Date(moment(selStartDate).local());

		// 				var selEndDate = moment.utc(selectedEvent.end);
		// 				var convertedEndDate = new Date(moment(selEndDate).local());

		// 				let blockingDate = convertedStartDate,
		// 					startTime = `${this.calculateAMPM(eventDetails.slot1)}`,
		// 					endTime = `${this.calculateAMPM(eventDetails.slot2)}`,
		// 					dateToBlock = changedDate,
		// 					endDate = convertedEndDate,
		// 					reason = eventDetails.slot2;

		// 				let finalBlockingObj = {
		// 					blockingDate,
		// 					startTime,
		// 					endTime,
		// 					reason,
		// 					dateToBlock,
		// 					noOfRecursion: 0,
		// 					startTiming: selectedEvent.start,
		// 					endTiming: selectedEvent.end,
		// 					//   monthToBlock,
		// 					endDate,
		// 					cloningEvent: true,
		// 					userlocation,
		// 					exclude: true,
		// 					excludeId: eventDetails._id,
		// 					excludeDate: convertedDate,
		// 					recurrence: eventDetails.recurrence
		// 				}
		// 				// 
		// 				// return;
		// 				this.props.appointmentactions.yearlyBlockAvailability(finalBlockingObj, this.props)
		// 				// 
		// 				// if (data == 1)
		// 				// this.props.gapiAction.putGapiToken(bodyData, this.props);
		// 				// if (data == 2)
		// 				// 	this.props.gapiAction.putOutlookToken(bodyData, this.props)
		// 			}
		// 		},
		// 		{
		// 			label: 'Recurring',
		// 			size: 'small',
		// 			onClick: () => {
		// 				let userToken = localStorage.getItem('token');
		// 				let specialistId = localStorage.getItem('userId');
		// 				let obj = {
		// 					userToken: userToken,
		// 					specialistId: specialistId,
		// 					event: event.extendedProps,
		// 					userlocation: moment.tz.guess()
		// 				};
		// 				this.setState({
		// 					deletingEvent: true
		// 				})
		// 				this.props.actions.deleteRecurringEvents(obj, this.props);
		// 			}
		// 		}
		// 	]
		// });

	}
	editDeleteBlockingEvent = (event) => {
		
		// return
		this.props.closeEditDetailAndOpenEditBlockingModal(event);

	}

	render() {
		// debugger;
		// let start = moment(this.props.eventData.start).format('DD-MMM-YYYY');
		// let end = moment(this.props.eventData.start).add(30, 'minutes').format('DD-MMM-YYYY');
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		let start = moment(this.props.eventData.start).format('DD-MM-YYYY hh:mm A') + " " + userlocation;
		let end = moment(this.props.eventData.end).format('DD-MM-YYYY hh:mm A') + " " + userlocation;
		
		
		return (
			<Modal show={this.props.openModal} size="modal-sm" onHide={this.props.hideEventDetailsModal}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.hideEventDetailsModal} /> */}
					<div className="signIn text-capitalize " style={{ fontSize: '17px' }}>{this.props.eventData.desc}
						{this.props.eventData.title == "Slot Unavailable" ?  <span style={{ float: 'right' }} >
							<Link style={{ cursor: 'pointer', marginRight: 10 }} onClick={() => this.editDeleteBlockingEvent(this.props.eventData)} className="deleteLink"><img style={{ width: "14px" }} src={require('../../images/edit.png')} alt="" width="14px" /></Link>
							<Link style={{ cursor: 'pointer' }} onClick={() => this.deleteBlockingEvent(this.props.eventData)} className="deleteLink"><img style={{ width: "14px" }} src={require('../../images/delete.png')} alt="" width="14px" /></Link>
						</span>: ''}
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="myFeedbacks ">
						<div className="row">
							<div className="signIn col-lg-5 col-md-5 col-sm-3 col-xs-5 text-right padding10 mobilewidthdevice" style={{ fontSize: '15px' }}> {this.props.eventData.title == 'Slot Unavailable' ? 'Reason:' : 'Mode:'}</div><div className="col-lg-7 col-md-7 col-sm-9 col-xs-7 padding10 mobilewidthdevice9"> <span className="paddingtop2">{this.props.eventData.title == 'Slot Unavailable' ? this.props.eventData.reason : this.props.eventData.title}</span></div>
						</div>
						<div className="row">
							<div className="signIn col-lg-5 col-md-5 col-sm-3 col-xs-5 text-right padding10 mobilewidthdevice" style={{ fontSize: '15px' }}>Start :</div><div className="col-lg-7 col-md-7 col-sm-9 col-xs-7 padding10 mobilewidthdevice9">
								<span className="paddingtop2">{start} {this.props.eventData.slot1}
								</span>
							</div>
						</div>
						<div className="row">
							<div className="signIn col-lg-5 col-md-5 col-sm-3 col-xs-5 text-right padding10 mobilewidthdevice" style={{ fontSize: '15px' }}>End :</div><div className="col-lg-7 col-md-7 col-sm-9 col-xs-7 padding10 mobilewidthdevice9">
								<span className="paddingtop2">
									{end}  {this.props.eventData.slot2}
								</span>
							</div></div>
					</div>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
function mapStateToProps(state, ownProps) {
	return {
		specialist: state.specialist,
	};
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(specialistActions, dispatch),

		// actions: bindActionCreators(signinActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Signin);
